
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Select } from "./Select.js";
import { writeLanguage } from "../LocalStorageHelper.js";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { unwrap } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";

export function LanguageSelector(props) {
    const patternInput = useTranslation();
    const t = patternInput[0];
    const i18next = patternInput[1];
    const currentLanguage = i18next.language;
    const selectedLanguage = (currentLanguage === "en") ? {
        label: t("languages.en"),
        value: currentLanguage,
    } : ((currentLanguage === "de") ? {
        label: t("languages.de"),
        value: currentLanguage,
    } : ((currentLanguage === "nl") ? {
        label: t("languages.nl"),
        value: currentLanguage,
    } : ((currentLanguage === "fr") ? {
        label: t("languages.fr"),
        value: currentLanguage,
    } : ((currentLanguage === "it") ? {
        label: t("languages.it"),
        value: currentLanguage,
    } : ((currentLanguage === "uk") ? {
        label: t("languages.uk"),
        value: currentLanguage,
    } : ((currentLanguage === "pl") ? {
        label: t("languages.pl"),
        value: currentLanguage,
    } : ((currentLanguage === "sq") ? {
        label: t("languages.sq"),
        value: currentLanguage,
    } : ((currentLanguage === "hr") ? {
        label: t("languages.hr"),
        value: currentLanguage,
    } : ((currentLanguage === "ro") ? {
        label: t("languages.ro"),
        value: currentLanguage,
    } : ((currentLanguage === "sr") ? {
        label: t("languages.sr"),
        value: currentLanguage,
    } : {
        label: currentLanguage,
        value: currentLanguage,
    }))))))))));
    return createElement(Select, {
        ComponentState: "enabled",
        IsClearable: false,
        NoOptionsMessage: "",
        OnChange: (value) => {
            if (value == null) {
            }
            else {
                const lng = value.value;
                props.ChangeCallback(lng);
                const pr = i18next.changeLanguage(lng);
                pr.then();
                writeLanguage(lng);
            }
        },
        Options: ofArray([{
            label: t("languages.en"),
            value: "en",
        }, {
            label: t("languages.de"),
            value: "de",
        }, {
            label: t("languages.nl"),
            value: "nl",
        }, {
            label: t("languages.fr"),
            value: "fr",
        }, {
            label: t("languages.it"),
            value: "it",
        }, {
            label: t("languages.pl"),
            value: "pl",
        }, {
            label: t("languages.uk"),
            value: "uk",
        }, {
            label: t("languages.sq"),
            value: "sq",
        }, {
            label: t("languages.hr"),
            value: "hr",
        }, {
            label: t("languages.ro"),
            value: "ro",
        }, {
            label: t("languages.sr"),
            value: "sr",
        }]),
        PlaceholderKey: "",
        TestId: "profile-language-select",
        Value: unwrap(selectedLanguage),
    });
}

